import { PrivacyPage } from './privacy-page'
import { NEXUS_PRIVACY_PAGE_NAMESPACE } from '@otto-ec/eprivacy-privacy-page'
import { eventQBus } from '@otto-ec/global-resources/event-q-bus'
import { AppsAdapter } from '../adapter/apps.adapter'
import { loggingService } from '../utils/logging/logger.instance'
import { cookie } from '@otto-ec/global-resources/cookie'
import { Cookies } from '../adapter/cookies'
import { cmp } from '@otto-ec/eprivacy-cmp'

declare global {
  interface Window {
    o_privacyPage: PrivacyPage
  }
}
export const bootstrap = () => {
  /*                                                                        */
  const privacyPage = new PrivacyPage(
    document,
    cmp,
    eventQBus,
    new AppsAdapter(new Cookies(cookie)),
    loggingService
  )
  window.o_privacyPage = privacyPage
  initNexus(privacyPage)
}
function initNexus(privacyPage: PrivacyPage): void {
  otto[NEXUS_PRIVACY_PAGE_NAMESPACE].assignNamespace({
    handleAppDseSuccess: () => privacyPage.handleAppDseSuccess(),
    handleAppDseError: (errorMessage?: string) =>
      privacyPage.handleAppDseError(errorMessage),
  })
}

bootstrap()
